export const SET_WEBSHOP_TIPS_CONFIG = 'SET_WEBSHOP_TIPS_CONFIG'
export const SET_WEBSHOP_TIPS_CONFIG_IS_LOADING = 'SET_WEBSHOP_TIPS_CONFIG_IS_LOADING'
